export default "__VITE_ASSET__b9fab158__"